// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../_redux/customers/customersActions";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../../_metronic/_helpers";
import * as uiHelpers from "../../CustomersUIHelpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useCustomersDebtTableUIContext } from "./CustomersDebtTableUIContext";
import { NavLink } from "react-router-dom";
import CsvDownload from "react-json-to-csv";
import { MoneyFormatterCustom } from "../../../../../formatters/CustomFormatters";
export function CustomersDebtTable(props) {
  // Customers UI Context
  const CustomersDebtTableUIContext = useCustomersDebtTableUIContext();

  const customersUIProps = useMemo(() => {
    return {
      ids: CustomersDebtTableUIContext.ids,
      setIds: CustomersDebtTableUIContext.setIds,
      queryParams: CustomersDebtTableUIContext.queryParams,
      setQueryParams: CustomersDebtTableUIContext.setQueryParams,
    };
  }, [CustomersDebtTableUIContext]);

  // Getting curret state of customers list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.customers }),
    shallowEqual
  );
  const { totalCount, entities, listLoading, error } = currentState;

  // // Customers Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // clear selections list
    customersUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchCustomersDebt(customersUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersUIProps.queryParams, dispatch]);
  // Table columns

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: customersUIProps.queryParams.pageSize,
    page: customersUIProps.queryParams.pageNumber,
    showTotal: true,
  };

  let totalDebts = 0;

  if (entities != null && entities.length > 0) {
    totalDebts = entities
      .map((item) => item.customerSum)
      .reduce((prev, next) => prev + next);

    if (entities[0].currency == undefined) {
      console.log("no currency found" + entities);
    } else totalDebts = MoneyFormatterCustom(totalDebts, entities[0].currency);
  }

  if (error == 10) {
    return (
      <div className="card-body pt-2 pb-0">
        <span style={{ color: "red" }}>
          This data is blocked because Some of your customers require Tax Id
        </span>

        <NavLink className="menu-link menu-toggle" to="/customers">
          <span className="menu-text">
            {" "}
            Please update your Customer details
          </span>
        </NavLink>
      </div>
    );
  } else {

    let slice = []
    if(entities !== null){
      if (customersUIProps.queryParams.pageNumber > 1) {
        slice = entities.slice(customersUIProps.queryParams.pageSize * (customersUIProps.queryParams.pageNumber - 1), customersUIProps.queryParams.pageSize * customersUIProps.queryParams.pageNumber)
      }
      else {
        slice = entities.slice(0, customersUIProps.queryParams.pageSize)
      }
    }
    

    return (
      <>
        {/* <h3>Total Debt: {totalDebts}</h3> */}
        <CsvDownload
          type="button"
          className="btn btn-primary float-right"
          data={entities}
        >
          Export
        </CsvDownload>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <Pagination
                isLoading={listLoading}
                paginationProps={paginationProps}
              >
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  bordered={false}
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  remote
                  keyField="customercode"
                  data={slice}
                  columns={props.columns}
                  //defaultSorted={[{ dataField: props.sortBy, order: "asc" }]}
                  onTableChange={getHandlerTableChange(
                    customersUIProps.setQueryParams
                  )}
                  {...paginationTableProps}
                >
                  <PleaseWaitMessage entities={entities} />
                  <NoRecordsFoundMessage entities={entities} />
                </BootstrapTable>
              </Pagination>
            );
          }}
        </PaginationProvider>
      </>
    );
  }
}
